import React from 'react'
import './RadioButtonGroup.scss'
import classNames from 'classnames'

function RadioButtonGroup<T extends string = string>(props: {
  onSelect: (item: RadioType.Item<T> | null) => void
  options: RadioType.Item<T>[]
  selected: T | null
}) {
  const { onSelect, options, selected } = props

  return (
    <div className="RadioButtonGroup">
      {options.map(option => {
        return (
          <label key={option.key} className="radioButton" htmlFor={option.key} onChange={() => onSelect(options.find(it => it.key === option.key) ?? null)}>
            <input type="radio" name="listFormat" id={option.key} />
            <span
              className={classNames('radio-btn', { 'checked': selected === option.key })}
            />
            {option.label}
          </label>
        )
      })}
    </div>
  )
}

/* eslint-disable @typescript-eslint/no-namespace */
/* eslint-disable no-redeclare */
declare namespace RadioType {
  export interface Item<T extends string> {
    label: React.ReactNode
    key: T
  }
}

export default RadioButtonGroup